<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="5">
                        <v-card-title class="titulopagina">REPORTE DE STOCK HARINA</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            v-model="bodega"
                            label="Incluir Stock Reproceso"
                            color="blue"
                            class="float-right"
                            hide-details
                        ></v-switch>
                    </v-col>
                    <v-col cols="1">
                        <v-btn color="green darken-1" class="float-right" small dark @click="download" v-bind:disabled="!can_download">Excel</v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn color="blue darken-1" class="float-right" small dark @click="cargarStockHarina()"><v-icon>loop</v-icon></v-btn>
                    </v-col>
                    <v-col cols="2">
                        <date-picker v-model="fecha" placeholder ="Seleccione Fecha" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD" class="float-right mr-1"></date-picker>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                    {{`TOTAL KILOS: ${total_kg}`}}
                    <v-spacer></v-spacer>
                    <!-- <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field> -->
                    </v-card-title>
                    <v-data-table
                    :headers="columnas"
                    :items="lista"
                    ></v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <loader-compartido></loader-compartido>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Loader_Compartido from '@/components/shared/Loader_Compartido.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
         columnas: [
            {
                text: 'Lote',
                align: 'center',
                sortable: true,
                value: 'nombre_lote',
                class:'cabecera'
            },
            { text: 'Fecha Lote',
                align: 'center',
                sortable: true, 
                value: 'fecha_lote' ,
                class:'cabecera'
            },
            { text: 'Cantidad Maxisacos Disponibles',
                align: 'center',
                sortable: true, 
                value: 'cantidad_jumbos' ,
                class:'cabecera'
            },
            { text: 'Maxisacos N°',
                align: 'left',
                sortable: false, 
                value: 'maxisacos' ,
                class:'cabecera'
            },
            { text: 'Kilos Disponibles',
                align: 'center',
                sortable: false,
                value: 'kilos' ,
                class:'cabecera'
            },
        ],
        lista:[],
        fecha:'',
        total_kg:0,
        url_excel: '',
        bodega: false,
        can_download: false,
    }),
    mounted() {
        this.fecha = this.moment().format('YYYY-MM-DD');
        this.cargarStockHarina();
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte de Stock Harina`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un listado del stock de cada lote de harina, con su respectivos maxisacos y kilos disponibles hasta el día que se indica en el campo de fecha.`},
                {   tipo:`label`,   texto:`- Al cargar la página, se cargará el stock existente hasta el día actual. En caso de querer cargar información de días anteriores, se debe indicar en el campo de fecha ubicado arriba a la derecha de la página. En caso de querer incluir el stock de reproceso, se deberá marcar la casilla correspondiente arriba de la pantalla`},
                {   tipo:`label`,   texto:`- Al pulsar el botón "Excel", se exportará toda la información mostrada según la fecha indicada en formato Excel.`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarStockHarina(){
            //this.mostrarLoading('Cargando Stock Harina...');
            this.mostrarLoading({titulo:'Cargando Stock Harina...',color:'green'})

            let url = `${this.base_url}stock_harina/${this.fecha}/${this.bodega}`;
            await this.axios.get(url,this.headers).then((res)=>{
                //console.log('res',res.data);
                this.lista = res.data.data;
                this.total_kg = res.data.total_kilos;
                this.url_excel = res.data.url_excel;
                if(this.lista.length > 0){
                    this.can_download = true;
                }
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },
        download(){
            window.location.href = this.download_url + this.url_excel;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers', 'download_url'])
    },
    components:{
        'loader-compartido':Loader_Compartido,
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
}
</script>